/**
 * ShortenStringWithEllipse
 *
 * @description Helper method to reduce the length of text and add ellipse
 * @param {string}             text   Selected text
 * @param {undefined | number} length Length of text before ellipse
 * @returns {string} Shortened string
 */
export const shortenStringWithEllipse = (text: string, length: undefined | number = 25): string => {
  if (text.length <= length) {
    return text;
  }

  return `${text.substring(0, length)} ...`;
};